export const DEFAULT_AUTH_MESSAGE_COLORS = {
  genuine: { color: '#77c61a' },
  active: { color: '#65bbef' },
  fake: { color: '#f43838' }
}

export default {
  version: 4,
  logo: '',
  tabs: ['cms_01'],
  theme: {
    primary: '#2095F2FF',
    accent: '#2095F2FF'
  },
  title: 'Scantrust',
  footer: {},
  cookie: {},
  tab_flow: {
    active: [
      ['cms_01']
    ],
    fake: [
      ['cms_01']
    ],
    genuine: [
      ['cms_01']
    ]
  },
  'product-infos': {
    auth_message: {
      fake: {},
      active: {},
      genuine: {}
    },
    auth_message_styles: { ...DEFAULT_AUTH_MESSAGE_COLORS },
    hide_serial_number: false,
    display_mode: 'contain'
  },
  cms_01: {
    body: [],
    icon: 'more',
    type: 'cms',
    label: {
      en: ''
    }
  },
  'track-and-trace': {
    icon: 'track-and-trace',
    logo: './static/images/theme-files/square-logo.png',
    type: 'track-and-trace',
    label: {},
    journey: []
  },
  available_languages: ['en'], // legacy
  default_language: '',
  enabled_languages: [],
  reviewed_languages: [],
  'auth-app-branding': {
    background: '#ffffff',
    primary: '#222222',
    secondary: '#15bbf0',
    forceDefaultLanguage: '',
    torchControlInVideoAuth: true
  }
}
